export const referrals = {
  appBarTitle: "Referrals",
  referralsList: {
    totalReferrals: "Total Referrals",
    totalRegisteredInvitees: "Total Registered Invitees",
    totalPendingInvitees: "Total Pending Invitees",
    totalExpiredRewards: "Total Number of Expired Rewards",
    table: {
      inviterName: "Inviter Name",
      inviterRole: "Inviter Role",
      invitationDate: "Invitation Date",
      inviteeName: "Invitee Name",
      inviteePhoneNumber: "Invitee Phone Number",
      inviteeRole: "Invitee Role",
      inviteeRoleStatus: "Invitee Role Status",
      inviteeStatus: "Invitee Status",
      registerationDate: "Registration Date",
      switchedFrom: "Switched from",
      roleStatusOptions: {
        primary: "Primary",
        switched: "Switched",
      },
    },
    status: {
      unregistered: "Unregistered",
      failed: "Failed",
      unverified: "Unverified",
      verified: "Verified",
      acitve: "Active",
    },
    roles: {
      singleOwner: "Single Owner",
      fleetOwner: "Fleet Owner",
      driver: "Driver",
    },
  },
  referralsRewards: {
    totalEarnedRewards: "Total Earned Rewards",
    totalNumberRedeemedRewards: "Total Redeemed Rewards",
    totalAmountRedeemedRewards: "Total Redeemed Rewards Amount",
    table: {
      inviterName: "Inviter Name",
      inviterRole: "Inviter Role",
      inviterPhoneNumber: "Inviter Phone Number",
      NumberOfreferrals: "Number of Referrals",
      numberOfEarnedRewards: "Number of Earned Rewards",
      numberOfRedeemedRewards: "Number of Redeemed Rewards",
      numberOfSelectedRewards: "Number of Selected Rewards",
      numberOfExpiredRewards: "Number of Expired Rewards",
      totalAmountRedeemed: "Total Amount Redeemed (EGP)",
    },
  },
};
